import { useEffect, useRef, useState } from 'react';
// @mui
import { Box, Stack } from '@mui/material';

// tick
import Tick from '@pqina/flip';
import { DateTime } from 'luxon';


// mocks_


import './RUNWAYClock.css'
// ----------------------------------------------------------------------

export default function RUNWAYClock() {
  const [open, setOpen] = useState(null);


// create a ticker on an element with options
// const element = document.querySelector('#sectick');
const tickRef = useRef()
const tickInstance = useRef()

const dayRef = useRef()
const dayInstance = useRef()

useEffect(() => {
  

  if (!tickInstance.current) {
    tickInstance.current = Tick.DOM.create(tickRef.current, {
      // value: 0,
      didInit (tick) {
  
        const counter = Tick.count.up(DateTime.local().toFormat('yyyy-LL-dd 07:00'), {
          format: ['h', 'm']
        });
          counter.onupdate = (value) => {
              // by default value will contain an
              // array with days, hours, minutes, seconds
              tick.value = value;
              tickInstance.current.value = value
              dayInstance.current.value = DateTime.local().setZone('Asia/Bangkok').toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY) // 0.toFormat('ccccที่ d LLLyy')
          };
      
      }
      
    });
  }
  return () => Tick.DOM.destroy(tickRef);

},[]);

useEffect(() => {
  if (!dayInstance.current) {
    dayInstance.current = Tick.DOM.create(dayRef.current, {
      value: "",
      // didInit(tick) {

      //   // <Typography sx={{ fontSize: '2.8vw'}} color={'primary'}>{DateTime.local().setLocale('th-TH').setZone('Asia/Bangkok').toFormat('ccccที่ d LLL yyyy')}</Typography>
      //   Tick.helper.interval(
      //     // callback function receives total runtime
      //     (runtime) => {

                  
      //     },
      
      //     // interval between ticks
      //     60 * 60 * 1000,
      
      //     // we will manually start this timer
      //     { autostart:false }
      // );

      //   }

      }
    )
  }
  return () => {
    
  };
}, []);

  return (
    <>
      <Box sx={{ pb:5}}>

      <Stack direction={{sm : 'column', md: 'row' }} spacing={2}>
        <div ref={dayRef} className="tick">

          <span data-view="flip" />

          </div>

          <div ref={tickRef} className="tick" >
                    
            <div data-repeat="true" data-layout="horizontal center fit" data-transform="preset(h, m, s) -> delay">

              <div className="tick-group">

                  <div data-key="value" data-repeat="true" data-transform="pad(00) -> split -> delay">

                      <span data-view="flip" />

                  </div>

                  {/* <span data-key="label" data-view="text" className="tick-label" /> */}

              </div>

            </div>
          </div>

        </Stack>

      </Box>
     
    </>
  );
}
